import DetailActionButtons from './DetailActionButtons'

export default DetailActionButtons
// eslint-disable-next-line import/export
export * from './DetailActionButtons'
